import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { fetchLivePromotion } from '../../services/adminPromos.js';
import Logo from '../brand/Logo.jsx';
import Wordmark from '../brand/Wordmark.jsx';

const COLUMNS = [
  {
    heading: 'Browse',
    links: [
      { to: '/new', label: 'New Releases' },
      { to: '/secondhand', label: 'Secondhand Finds' },
      { to: '/subscription', label: 'Subscription' },
    ],
  },
  {
    heading: 'Chapters&Co',
    links: [
      { to: '/about', label: 'About the shop' },
      { to: '/contact', label: 'Contact' },
      { to: '/book-fair', label: 'Book fair' },
    ],
  },
  {
    heading: 'Help',
    links: [
      { to: '/policies/delivery', label: 'Delivery' },
      { to: '/policies/returns', label: 'Returns' },
      { to: '/policies/privacy', label: 'Privacy' },
      { to: '/policies/terms', label: 'Terms' },
    ],
  },
];

export default function SiteFooter() {
  const { data: promoData } = useQuery({
    queryKey: ['promotions', 'live'],
    queryFn: fetchLivePromotion,
  });
  const hasLivePromotion = Boolean(promoData?.promotion);

  const filteredColumns = COLUMNS.map((col) => ({
    ...col,
    links: col.links.filter((link) => link.to !== '/book-fair' || hasLivePromotion),
  }));

  return (
    /* `slab`, not `ink`: this plate stays dark in both themes (see the token
       comment in styles/index.css), which is also why the mark stays the light
       one and does not follow the theme. */
    <footer className="bg-slab text-slab-ink mt-16 sm:mt-24">
      <div className="page-gutter mx-auto max-w-(--container-page) py-12 sm:py-16">
        <div className="grid gap-8 sm:gap-12 grid-cols-1 sm:grid-cols-2 md:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div className="sm:col-span-2 md:col-span-1">
            <div className="flex items-center gap-3">
              <Logo variant="light" size={30} title="Chapters&Co" />
              <Wordmark className="text-xl" />
            </div>
            <p className="text-read text-slab-ink-80 font-display mt-4 sm:mt-5 max-w-[32ch] sm:max-w-[26ch]">
              An independent bookshop in Colombo. Secondhand copies chosen one at a time, and new
              titles direct from publishers.
            </p>
          </div>

          {filteredColumns.map((column) => (
            <nav key={column.heading} aria-label={column.heading}>
              <h2 className="label text-slab-ink-60">{column.heading}</h2>
              <ul className="mt-4 list-none space-y-2.5 p-0">
                {column.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-slab-ink-80 hover:text-slab-ink no-underline transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="border-slab-rule mt-16 flex flex-col gap-3 border-t pt-6 sm:flex-row sm:items-baseline sm:justify-between">
          <p className="label text-slab-ink-60">
            &copy; {new Date().getFullYear()} Chapters&amp;Co. All rights reserved.
          </p>
          <p className="label text-slab-ink-60">Colombo, Sri Lanka</p>
        </div>
      </div>
    </footer>
  );
}
